import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { mcpCatalogApi } from '../services/api';
import type {
  McpProviderCatalogEntry,
  McpProvidersResponse,
} from '../types/mcp';

/**
 * MCP provider catalog. Org-global, content-only — used by the picker, the
 * catalog-driven form branch, and list-view logo rendering. Cached
 * aggressively (1h) because the catalog rarely changes.
 */
export function useMcpProviders() {
  return useQuery<McpProvidersResponse>({
    queryKey: ['conn', 'mcp-providers'],
    queryFn: () => mcpCatalogApi.list(),
    staleTime: 60 * 60 * 1000,
  });
}

export function useMcpProviderById(providerId: string | undefined) {
  const { data } = useMcpProviders();
  return useMemo<McpProviderCatalogEntry | undefined>(() => {
    if (!providerId || !data) return undefined;
    return data.providers.find((p) => p.providerId === providerId);
  }, [data, providerId]);
}
